module.exports = __webpack_public_path__ + "img/info.502ad65c.png";